import React from 'react';
import * as moment from 'moment';

const Header = (props) => {

  const { headerImage, dateFormat } = props.data;
  const { output} = props;
  const todayDate = String(moment().format(dateFormat));


  return (
    <div className="nppe2-fc-feeding-guidelines-header" id="fc-screenshot-feeding-guidelines-header">
      <div className="row">
        <div className="header">
          <img src={headerImage} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 nppe2-fc-feeding-guidelines-header__logo"></div>
        <div className="col-md-6">
          <div className="row">
            <div className="col-xs-12 mr-2 nppe2-fc-feeding-guidelines-header__date">
              <p>{todayDate}</p>
              <p>{output.pet.name}</p>
              <p>{output.pet.clinicRecordNumber}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default Header;
